import { ReactNode, FormEvent } from 'react';
import { useFormikContext } from 'formik';
import { removeCurrentNote } from 'modules/networkTools/localStorageTokens';
import { removeNote } from 'store/clientProfile/clientProfileSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { useAutosaveContext } from '../context/autosaveContext';
import { NoteFormValues } from '../utils/validation';
import { createDefaultValues } from '../utils/helpers';

type FormProps = {
  children: ReactNode;
  onSubmit?: () => Promise<void> | void;
  id?: string;
};

export const Form = ({ children, onSubmit, id = 'noteEdit' }: FormProps) => {
  const dispatch = useAppDispatch();
  const formik = useFormikContext<NoteFormValues>();
  const { clearLastSaved } = useAutosaveContext();
  const sitesEnabled = useAppSelector((state) => state.clients.client.data?.enableProgramSites);
  const isBillingEnabled = useAppSelector((state) => state.clients.client.data?.enableBilling);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSubmit) {
      await onSubmit();
    } else {
      await formik.handleSubmit();
    }
  };

  const handleReset = () => {
    formik.resetForm({
      values: createDefaultValues(sitesEnabled, isBillingEnabled)
    });
    removeCurrentNote();
    dispatch(removeNote());
    clearLastSaved();
  };

  return (
    <form onSubmit={handleSubmit} onReset={handleReset} id={id}>
      {children}
    </form>
  );
};
